import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lms-dynamic-form-error',
  templateUrl: './dynamic-form-error.component.html',
  styleUrls: ['./dynamic-form-error.component.scss']
})
export class DynamicFormErrorComponent implements OnInit, OnChanges {
  @Input() formError: any;
  formErrorMessage: string;
  formFieldsErrors = [];

  constructor(public translate: TranslateService) {}

  ngOnInit() {}

  ngOnChanges() {
    this.checkErrors();
  }

  checkErrors() {
    this.formFieldsErrors = [];
    if (this.formError) {
      // Get specific errors for each field
      if (this.formError.fields) {
        this.formError.fields.forEach((value) => {
          this.formFieldsErrors.push(this.getFieldErrorMessage(value));
        });
      } else {
        // Get general error message for the form
        this.formErrorMessage = this.getFormErrorMessage(this.formError);
      }
    }
  }

  getFormErrorMessage(error) {
    const message = this.translateError(error.serverMessage, error.payload, error.responseStatusMessage);
    return message;
  }

  getFieldErrorMessage(fieldError) {
    let message = 'Unknown ... ';
    if (fieldError) {
      const key = 'messages.form.error.field.' + fieldError.kind;
      message = this.translateError(key, { path: fieldError.path, param: fieldError.param }, fieldError.message);
    }
    return message;
  }

  translateError(serverMessage: any, payload: any, defaultMessage: any) {
    let message;
    this.translate.get(serverMessage, payload).subscribe((res: string) => {
      if (res === serverMessage) {
        // If the value returned by the translator is the serverMessage itself, that means that it was not found so
        // the message received from the server will be the message displayed on the screen
        message = defaultMessage;
      } else {
        message = res;
      }
    });
    return message;
  }
}
